angular.module 'zc.core'

.directive 'positiveOrNegative', ($filter) ->
  directive =
    restrict: "A"
    require: '?value'
    scope: {
      zero: "@" # the value which is considered border between 0 and 1
      type: "@" # the value which is considered border between 0 and 1
      positivePrefix: "@" # false if not to prepend +, default ("+")
      zeroIsNegative: "@" # true or false if - is considered negative or not (default true)
      showsZero: '<'
      fractionSize: '<'
      value: "=value"
    }
    template: """
      <span class="positive-or-negative label" ng-class="statusClass" ng-if="shows">{{prefix}}{{showValue}}</span>
    """

    link: (scope, element, attrs) ->
      # default values
      scope.value ||= 0

      scope.statusClass = ""
      scope.prefix = ""

      scope.$watch 'value', (oldValue, newValue) ->
        scope.type = "number" if typeof scope.type == "undefined"
        scope.positivePrefix = "+" if typeof scope.positivePrefix == 'undefined'
        scope.zeroIsNegative = true if typeof scope.zeroIsNegative == 'undefined'
        scope.showsZero = true if typeof scope.showsZero == 'undefined'
        if typeof scope.fractionSize == 'undefined'
          fractionSize = 0
        else
          fractionSize = scope.fractionSize
        scope.zero ||= 0

        if scope.value < scope.zero or
            (scope.zeroIsNegative && scope.value == scope.zero)
          scope.statusClass = "negative"
          scope.prefix = ""
          scope.type
        else
          scope.statusClass = "positive"
          scope.prefix = scope.positivePrefix if scope.positivePrefix

        if !scope.value && scope.value != 0
          scope.showValue = ""
          scope.prefix = ""
        else if scope.type == "percentage"
          scope.showValue = $filter('number')(scope.value * 100, fractionSize) + "%"
        else
          scope.showValue = $filter('number')(scope.value , fractionSize)

        if scope.showsZero
          scope.shows = true
        else if scope.value is scope.zero
          scope.shows = false
        else
          scope.shows = true

  directive



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/positive_or_negative.js.coffee